import * as Pioneer from "pioneer";

import { Config } from "../config/config";
import { gmapStore } from "../managers/globalState";

import { GMAP_CATEGORIES, GMAP_LATEST_LIMIT } from "../config/constants";
import globalRefs from "../managers/globalRefs";
//import momenti from "moment-hijri";
import moment from "moment-timezone";

const updateYear = (newYearIndex) => {
  gmapStore.setGlobalState({ yearIndex: newYearIndex });
};

const updateCategory = (category) => {
  gmapStore.setGlobalState({ categoryIndex: category });
};

/**
 * Loops through all the gmap and creates an array of all years spanning them.
 * @param {Array} allGmap
 * @returns {Array}
 */
const getAllYearsGmap = (allGmap) => {
  let allYears = [["all", "كل السنوات"]];

  allGmap.map((gmap) => {
    const currYear = gmap.date.substring(0, 4);
    let all = allYears.filter((v) => {
      return v[0] == currYear;
    });
    if (all.length == 0) {
      const display = moment(gmap.date).format("YYYY");
      allYears.push([currYear, display]);
    }
  });

  return allYears.sort((a, b) => b - a);
};

const filterGmap = (gmaps, gmapYears, yearIndex, gmapcategoryIndex) => {
  // console.log("filter!!!!!!!!!", gmaps, yearIndex, gmapcategoryIndex)
  return gmaps.filter((gmap) => {
    if (GMAP_CATEGORIES.length > 0) {
      const year = gmapYears[yearIndex][0];
      const category = GMAP_CATEGORIES[gmapcategoryIndex];
      const yearFilter = year === "all" || gmap.date.substring(0, 4) === year;
      const categoryFilter =
        category[0] === "all" ||
        gmap.imagecategory?.includes(
          category[0].replace(/ /g, "").toLocaleLowerCase(),
        );
      return yearFilter && categoryFilter;
    }
  });
};

/**
 * Load the texture of the given event.
 * @param {object} eventData
 */
const loadGmap = async (eventData) => {
  const { pioneer } = globalRefs;
  const {
    image_src,
    north_boundary,
    south_boundary,
    east_boundary,
    west_boundary,
  } = eventData || {};
  const lowerLeftLLA = new Pioneer.LatLonAlt();
  const upperRightLLA = new Pioneer.LatLonAlt();
  const earth = pioneer.get("main", "earth");
  const src = /^https?:\/\//.test(image_src || "")
    ? image_src
    : `${Config.baseCe2s2Url}${image_src}`;
  // console.log("loadGmap", src)

  const patchComponent = earth.getComponent(
    Pioneer.SpheroidLODComponent,
    "patch",
  );
  // const earthSpheroidComponent = earth.getComponent(Pioneer.SpheroidLODComponent);
  // Hide data patch.
  patchComponent.setRenderingEnabled(false);
  patchComponent.setMapping("cylinder");

  // Set patch texture.
  patchComponent.setTexture("color", src);

  lowerLeftLLA.set(
    Pioneer.MathUtils.degToRad(parseFloat(south_boundary)),
    Pioneer.MathUtils.degToRad(parseFloat(west_boundary)),
    0,
    true,
  );
  upperRightLLA.set(
    Pioneer.MathUtils.degToRad(parseFloat(north_boundary)),
    Pioneer.MathUtils.degToRad(parseFloat(east_boundary)),
    0,
    true,
  );
  patchComponent.setBounds(lowerLeftLLA, upperRightLLA);

  // Enable the patch.
  patchComponent.setEnabled(true);
  patchComponent.forceTextureSize("color", 0);

  // Wait until patch is loaded.
  try {
    await earth.waitTillInPlace();
    await patchComponent.getLoadedPromise(true, 30);
    //handle transparency
    const material = patchComponent._threeJsMaterials[0];
    if (material) {
      if (eventData.transparent) {
        material.transparent = true;
      } else {
        material.transparent = false;
      }
    }
  } catch (e) {
    console.warn("e: ", e);
  }
  // Show data patch.
  patchComponent.setRenderingEnabled(true);
};

/**
 * Enables the most recent event placemarks.
 * @param {number} number
 */
const getLimitedGmaps = (limit = GMAP_LATEST_LIMIT, currentGmapId = null) => {
  const { gmaps } = gmapStore.stateSnapshot;
  try {
    if (!Array.isArray(gmaps) || gmaps.length === 0) {
      return [];
    }

    if (currentGmapId) {
      const currentIndex = gmaps.findIndex(
        (gmap) =>
          gmap.external_id === currentGmapId || gmap.id === currentGmapId,
      );

      if (currentIndex !== -1) {
        return gmaps.slice(currentIndex + 1, currentIndex + 1 + limit);
      }
    }

    return gmaps.filter((event, i) => i < limit);
  } catch (e) {
    console.log("missing gmaps", e.message);
    return [];
  }
};

export {
  updateYear,
  updateCategory,
  getAllYearsGmap,
  loadGmap,
  getLimitedGmaps,
  filterGmap,
};
